import React from "react";
import { useState, useEffect } from "react";
// import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
// import {
//   setPerformanceCreateAction,
//   setPerformanceUpdateAction,
// } from "../../Redux/Slice";
// import "../../../StyleSheet/MainComponent/Performance/Performance.scss";
// import Modal from "react-bootstrap-modal/";
import Modal from "react-bootstrap/Modal";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { TimePicker } from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField";
import { SetCreatePermissionEmpAction } from "../../../../Redux/Slice";
import dayjs from 'dayjs';

function PermissionPopup(props) {
  const {
    show,
    setShow,
    editPayload,
    refresh,
    selectedPerformanceId,
    setEditPayload,
    PageIndex,
    status,
    search

  } = props;
  const [grading_name, setGrading_name] = useState("");
  const [total_points, setTotal_points] = useState("");
  const [value, setValue] = useState();
  const userId = useSelector(
    (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.id
  );
  const [data, setData] = useState({
    for_date: "",
    notes: "",
    from_time: "",
    to_time: "",
    user_id: userId,
  });
  const currentDate = dayjs();
  const startOfMonth = currentDate.startOf('month');
  const endOfMonth = currentDate.endOf('month');


  const [fieldErrors, setFieldErrors] = useState({
    for_date: "",
    notes: "",
    from_time: "",
    to_time: "",
  });
  const [editMode, setEditMode] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const dispatch = useDispatch();
  // useEffect(() => {
  //   if (userId !== undefined) {
  //     setData((prev) => ({
  //       ...prev,
  //       user_id: userId,
  //     }));
  //   }
  // }, [userId]);

  console.log(userId, "userId sdasd");

  const handleError = () => {
    const newFieldErrors = {};
    Object.entries(data).forEach(([key, value]) => {
      if (key === "for_date" && value.length === 0) {
        newFieldErrors[key] = "Permission date must not be empty.";
      } else if (key === "from_time" && value.length === 0) {
        newFieldErrors[key] = "From time must not be empty.";
      } else if (key === "to_time" && value.length === 0) {
        newFieldErrors[key] = "To time must not be empty..";
      } else if (key === "notes" && value.length === 0) {
        newFieldErrors[key] = "Notes must not be empty..";
      } else {
        newFieldErrors[key] = "";
      }
    });
    const hasError = Object.values(newFieldErrors).some((error) => error);
    setFieldErrors(newFieldErrors);
    if (!hasError) {
      console.log(data, "you youooajsfjojsljdflj");
      const payload = {
        data: {
          for_date: data.for_date,
          notes: data.notes,
          from_time: data.from_time,
          to_time: data.to_time,
          user_id: userId,
        },
        GetFilters: {
          status: status,
          search: search,
          page: PageIndex,
          page_size: 20
        }
      }
      dispatch(SetCreatePermissionEmpAction(payload));
      setEditPayload("");
      setData({
        for_date: "",
        notes: "",
        from_time: "",
        to_time: "",
        user_id: "",
      });
      setFieldErrors({
        for_date: "",
        notes: "",
        from_time: "",
        to_time: "",
      });
      setShow(false);
    }
  };
  const handleSubmit = () => {
    handleError();
    // if (Object.keys(editPayload).length > 0) {
    //   const payload = {
    //     data: {
    //       grading_name: grading_name,
    //       total_points: total_points,
    //     },
    //     id: editPayload.id,
    //   };
    //   handleError();
    //   //   dispatch(setPerformanceUpdateAction(payload));
    // } else {
    //   const payload = {
    //     grading_name: grading_name,
    //     total_points: total_points,
    //   };
    //   handleError();

    //   //   dispatch(setPerformanceCreateAction(payload));
    // }
  };
  useEffect(() => {
    if (Object.keys(editPayload).length > 0) {
      setEditMode(true);
      setGrading_name(editPayload.grading_name);
      setTotal_points(editPayload.total_points);
    }
  }, [editPayload]);
  const handleClose = () => {
    setEditPayload("");
    setShow(false);

    setData({
      for_date: "",
      notes: "",
      request_type: "",
      from_time: "",
      to_time: "",
    });
    setFieldErrors({
      for_date: "",
      notes: "",
      from_time: "",
      to_time: "",
    });
  };
  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const formatDateToHHMM = (dateString) => {
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };
  const handleDate = (inputDate, name) => {
    setFieldErrors((prev) => {
      return {
        ...prev,
        [name]: "",
      };
    });
    const value = formatDate(inputDate);
    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const openMe = () => {
    setTimeout(() => {
        const rsAnimFade = document.querySelector('.base-Popper-root.MuiPickersPopper-root.css-1anqmj6-MuiPopper-root-MuiPickersPopper-root');
        console.log(rsAnimFade, "Popup Element");

        if (rsAnimFade) {
            console.log("Popup found, applying styles...");
            rsAnimFade.style.cssText = `
                transform: translate3d(901px, 298.667px, 0px) !important;
                visibility: visible !important;
                opacity: 1 !important;
                z-index: 9999 !important;
                position:absolute !important;
            `;
        } else {
            console.log("Popup element not found");
        }
    }, 500); // Delay to allow the popup to render
};

 const openMeToTime  =()=>{
    setTimeout(() => {
        const rsAnimFade = document.querySelector('.base-Popper-root.MuiPickersPopper-root.css-1anqmj6-MuiPopper-root-MuiPickersPopper-root');
        console.log(rsAnimFade, "sdisad paosd rsAnimFade");
        if (rsAnimFade) {
            rsAnimFade.style.setProperty('transform', 'translate3d(956px, 356.667px, 0px)','important');
        }
    }, 50); // Delay to allow the element to render
 }

  

 
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.base-Popper-root.MuiPickersPopper-root.css-1anqmj6-MuiPopper-root-MuiPickersPopper-root');
  

    setTimeout(() => {
        const rsAnimFade = document.querySelector('.base-Popper-root.MuiPickersPopper-root.css-1anqmj6-MuiPopper-root-MuiPickersPopper-root');
        if (rsAnimFade) {
            rsAnimFade.style.setProperty('display', 'none', 'important');
        }
    }, 50); 

   }

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      className="modelman"
      size="lg"
      backdrop="static"
    >
      <Modal.Header className="popHead">
        <Modal.Title>
     
            Permission Request
        </Modal.Title>
        <div className="CloseIcon" onClick={handleClose}>
          <CloseOutlinedIcon />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="row">

          <div className="col mt-3">
            <label className="form-label" htmlFor="leaveDate">
              Permission Date<span style={{ color: "red" }}>*</span>
            </label>
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                style={{ width: "100%" }}
                onChange={(e) => {
                  handleDate(e?.$d, "for_date");
                }}
                shouldDisableDate={(date) => {
                  const today = dayjs();
                  const startOfYear = dayjs().startOf('year');
                  const endOfYear = dayjs().endOf('year');
      
                  // Disable dates outside the current year or in the future
                  return date.isBefore(startOfYear, 'day') || date.isAfter(today, 'day');
              }}
      
        
              />
              {/* {error.leaveDate && <p>Leave date must be selected.</p>} */}
              {/* {fieldErrors.for_date && (
                <div
                  className="error"
                  style={{
                    color: "red",
                    height: "20px",
                    padding: "5px",
                  }}
                >
                  {fieldErrors.for_date}
                  <span style={{ color: "red" }}>*</span>
                </div>
              )} */}
            {/* </LocalizationProvider> */} 
            <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
        style={{ width: "100%" }}
        onChange={(e) => {
            handleDate(e?.$d, "for_date");
        }}
        shouldDisableDate={(date) => {
            const today = dayjs();
            const endOfYear = dayjs().endOf('year');

            // Disable dates that are in the past (including today) or outside the current year
            return date.isBefore(today, 'day') || date.isAfter(endOfYear, 'day');
        }}
    />
    {fieldErrors.for_date && (
        <div
            className="error"
            style={{
                color: "red",
                height: "20px",
                padding: "5px",
            }}
        >
            {fieldErrors.for_date}
            <span style={{ color: "red" }}>*</span>
        </div>
    )}
</LocalizationProvider>

          </div>



          <div className="col mt-3 OndutyCalanderDesignss">
            <label className="form-label" htmlFor="leaveDate"style={{marginLeft:"-15px"}}>
              Permission Time<span style={{ color: "red" }}>*</span>
            </label>

            <div className="row">

              <div className="OndutyCalendarDesgin">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={data.from_time}
                    onChange={(newValue) =>
                      setData((prev) => {
                        return {
                          ...prev,
                          from_time: formatDateToHHMM(newValue.$d),
                        };
                      })
                    }
                    onOpen={() => {
                      openMe()
                    }}
                 onClose={() => {
                    CloseDateRange()
                       }}

                    label="From Time"
                    renderInput={(params) => <TextField {...params} />}
                  />

                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={data.to_time}
                    onChange={(newValue) =>
                      setData((prev) => {
                        return {
                          ...prev,
                          to_time: formatDateToHHMM(newValue.$d),
                        };
                      })
                    }
                    onOpen={() => {
                      openMeToTime()
                    }}
                 onClose={() => {
                    CloseDateRange()
                       }}
                    renderInput={(params) => <TextField {...params} />}
                    label="To Time"
                  />

                </LocalizationProvider>
              </div>
              <div style={{ display: "flex" }} >
                {fieldErrors.from_time && (
                  <div
                    className="error"
                    style={{
                      color: "red",
                      height: "20px",
                      padding: "5px",
                    }}
                  >
                    {fieldErrors.from_time}
                    <span style={{ color: "red" }}>*</span>
                  </div>
                )}
                {fieldErrors.to_time && (
                  <div
                    className="error"
                    style={{
                      color: "red",
                      height: "20px",
                      padding: "5px",
                    }}
                  >
                    {fieldErrors.to_time}
                    <span style={{ color: "red" }}>*</span>
                  </div>
                )}
              </div>




            </div>
          </div>

          <div className="col-12 section1">
            <label
              className="mt-4 mb-4"
              htmlFor="leaveDate"
              style={{ margin: "0" }}
            >
              {" "}
              Purpose<span style={{ color: "red" }}>*</span>
            </label>
            <textarea
              style={{
                width: "100%",
                height: "200px",
                border: "1px solid lightgrey",
                padding: "11px"
              }}
              value={data.notes}
              onChange={(e) => {
                setFieldErrors((prev) => ({
                  ...prev,
                  notes: "",
                }));
                setData((prev) => ({
                  ...prev,
                  notes: e.target.value,
                }));
              }}
            />
            {fieldErrors.notes && (
              <div
                className="error"
                style={{
                  color: "red",
                  height: "20px",
                  padding: "5px",
                }}
              >
                {fieldErrors.notes}
                <span style={{ color: "red" }}>*</span>
              </div>
            )}
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="RoleButton">

          <button class="btn CancelBtn" onClick={handleClose}>
            Cancel
          </button>
          <button
            class="CancelBtn btn"
            type="submit"
            onClick={(e) => {
              handleSubmit();
            }}
            style={{ marginBottom: "20px", background: "#234492", color: "white" }}

          >
            Submit
          </button>

        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default PermissionPopup;